import { SelectRowCell, Tooltip, TooltipContent, TooltipTrigger } from '@tlx/atlas';
import { FormattedMessage } from 'react-intl';

export function DisplaySelectRow({ disabled }: { disabled: boolean }) {
    if (disabled) {
        return (
            <Tooltip>
                <TooltipTrigger>
                    <span>
                        <SelectRow disabled={disabled} />
                    </span>
                </TooltipTrigger>
                <TooltipContent>
                    <FormattedMessage id="text_access_denied_employee" />
                </TooltipContent>
            </Tooltip>
        );
    }
    return <SelectRow />;
}

function SelectRow({ disabled }: { disabled?: boolean }) {
    return <SelectRowCell disabled={disabled} />;
}
